import { useEffect, useRef, useState } from 'react'
import { User } from '../../../data/models/user';
import { Billing } from '../../../data/models/billing';
import UserSelect from '../../components/menu/Form/select/UserSelect';
import { App, Button, Col, DatePicker, DatePickerProps, Empty, Input, notification, Progress, Row, Switch, Typography } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { makeRequest } from '../../helpers/axios-manipulator';
import { getCurrentUtcDate } from '../../helpers/current-utc-date-generator'
import React from 'react';
import Title from 'antd/es/typography/Title';
import RepresentationContract from '../../components/Billing/RepresentationContract';
import ArtistRepresentationContract from '../../components/Billing/ArtistRepresentationContract';
import { ArtistRep } from '../../../data/models/artist-rep';
import { green, red, orange } from '@ant-design/colors';
import NewUserModal from '../../components/NewUserModal';
import dayjs from 'dayjs';
const { Text } = Typography;

const ContractsScreen = () => {
    const [data, setData] = useState<User>({} as User);
    const [newSelectedUser, setNewSelectedUser] = useState<string>()
    const [contracts, setContracts] = useState<ArtistRep[]>([]);
    const [billing, setBilling] = useState<Billing>({} as Billing);
    const [contractsKey, setContractsKey] = useState<number>(1)

    const contractsPercent = contracts.reduce((sum, contract) => sum + contract.fee, 0);

    const [hasNewContract, setHasNewContract] = useState(false)
    const isAnyEditing = contracts.some(contract => contract.editing === true);
    const [loading, setLoading] = useState(false);

    const { message } = App.useApp();
    const [api, contextHolder] = notification.useNotification();



    const save = async () => {
        const hasDuplicateArtist = contracts.some((contract, index, array) => {
            return array.findIndex(c => c.artist_id === contract.artist_id) !== index;
        });
        if (hasDuplicateArtist && (data.type === 3 || data.type === 4))
            return api['error']({
                duration: 5,
                message: 'Error creating contract',
                description:
                    'It is not possible to add the same artist more than once',
            });
        setLoading(true)

        try {
            if (contracts) {
                const contractsResponse = await makeRequest({
                    origin: window.location.origin,
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    url: '/api-manipulate-contracts',
                    data: { contracts },
                });
                setContracts(contractsResponse)
                message.success('Contracts created with success!');
            }
            if (billing && Object.keys(data)?.length > 0) {
                const response = await makeRequest({
                    origin: window.location.origin,
                    method: billing.id ? 'put' : 'post',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    url: `${billing.id ? "/api-update-billing" : "/api-create-billing"}`,
                    data: { billing: { ...billing, rep_id: data.id, created_by: data.id, last_updated_by: data.id } },
                });
                setBilling(response)
            }
            setLoading(false)
        } catch (error) {
            message.error('something went wrong during the update')
            setLoading(false)
        }
    }

    const addEmptyContract = () => {
        const newContract = {
            id: "",
            artist_id: data.type === 1 ? data?.id : "",
            dealer_profile: "",
            dealer_username: "",
            rep_id: (data.type === 3 || data.type === 4) ? data?.id : "",
            rep_type: 4,
            status: "active",
            fee: 0,
            creation_date: getCurrentUtcDate(),
            last_updated_Date: getCurrentUtcDate(),
            last_updated_by: data?.id,
            editing: true
        };
        setContracts(prevContracts => [...prevContracts, newContract]);
        setHasNewContract(true)
    };

    const getRelatedContracts = async () => {
        try {
            const response = await makeRequest({
                origin: window.location.origin,
                method: 'get',
                url: `/api-available-contracts/${data?.id}/${data?.type}`,
                headers: {},
            });
            setContracts(response)
        } catch (error) {

        }
    }

    const getBilling = async () => {
        try {
            const response = await makeRequest({
                origin: window.location.origin,
                method: 'get',
                url: `/api-billing/${data?.id}`,
                headers: {},
            });
            setBilling(response)
        } catch (error) {

        }
    }
    const onChangeStartDate: DatePickerProps['onChange'] = (date, dateString) => {
        if (date)
            setBilling({ ...billing, start_date: date?.toDate() })
    };
    const onChangeEndDate: DatePickerProps['onChange'] = (date, dateString) => {
        if (date)
            setBilling({ ...billing, end_date: date?.toDate() })
    };

    useEffect(() => {
        if (data && Object.keys(data)?.length > 0) {
            getRelatedContracts();
            setBilling({} as Billing)
            if (data?.type === 3 || data?.type === 4) getBilling();
            setHasNewContract(false);
        }
    }, [data])

    useEffect(() => { setContractsKey(contractsKey + 1) }, [contracts])

    return (
        <>
            {contextHolder}
            <div>
                <label>User</label>
                <UserSelect update={loading} className='mb-5' setData={setData} data={data} route="/api-representative-users" selectedUser={newSelectedUser} />
            </div>

            {data &&
                <>
                    <Title className='mt-0' level={4}>Billing data</Title>
                    <Text>business premium</Text>
                    <Input
                        disabled={billing?.premium === undefined || billing?.premium === null}
                        className="mb-5"
                        value={billing?.premium ?? ''}
                        onChange={(e) => setBilling({ ...billing, premium: e.target.value === '' ? undefined : parseInt(e.target.value) || 0 })}
                    />
                    <Text>Status</Text>
                    <Input
                        className="mb-5"
                        value={billing?.status ?? ''}
                        onChange={(e) => setBilling({ ...billing, status: e.target.value === '' ? "" : e.target.value })}
                    />
                    <Text>Escrow enabled</Text>
                    <Switch
                        className="mb-5"
                        style={{ display: "block" }}
                        value={billing?.is_escrow_enabled} onChange={(e) => setBilling({ ...billing, is_escrow_enabled: e })} />
                    <Row gutter={8}>
                        <Col span={24} md={12}>
                            <Text>Start date</Text>
                            <DatePicker value={billing?.start_date ? dayjs(billing?.start_date) : null} showTime className="mb-5" style={{ display: "block" }} onChange={onChangeStartDate} />
                        </Col>
                        <Col span={24} md={12}>
                            <Text>End date</Text>
                            <DatePicker value={billing?.end_date ? dayjs(billing?.end_date) : null} showTime className="mb-5" style={{ display: "block" }} onChange={onChangeEndDate} />
                        </Col>
                    </Row>
                    <Text>Full name</Text>
                    <Input
                        className="mb-5"
                        value={billing?.full_name ?? ''}
                        onChange={(e) => setBilling({ ...billing, full_name: e.target.value === '' ? "" : e.target.value })}
                    />
                    <Text>Contact email</Text>
                    <Input
                        className="mb-5"
                        value={billing?.contact_email ?? ''}
                        onChange={(e) => setBilling({ ...billing, contact_email: e.target.value === '' ? "" : e.target.value })}
                    />
                    <Text>GoogleId</Text>
                    <Input
                        className="mb-5"
                        value={billing?.google_id ?? ''}
                        onChange={(e) => setBilling({ ...billing, google_id: e.target.value === '' ? "" : e.target.value })}
                    />
                    <Text>BizAdmin enabled</Text>
                    <Switch
                        className="mb-5"
                        style={{ display: "block" }}
                        value={billing?.is_bizadmin_enabled} onChange={(e) => setBilling({ ...billing, is_bizadmin_enabled: e })} />

                    {/* <Divider className="my-0" orientation="left" orientationMargin="0">
                        <Text strong>escrow account</Text> - <Text type={billing?.is_escrow_enabled ? "success" : "danger"}>{billing?.is_escrow_enabled ? "Active" : "Inactive"}</Text>
                    </Divider> */}
                    <Row gutter={8}>
                        <Col span={24} md={12}>
                            <Text>escrow id</Text>
                            <Input disabled className='mb-5' value={billing?.escrow_id || ''} />
                        </Col>
                        <Col span={24} md={12}>
                            <Text>escrow premium</Text>
                            <Input className='mb-5' value={billing?.escrow_premium || ''}
                                onChange={(e) => setBilling({ ...billing, escrow_premium: e.target.value === '' ? null : parseInt(e.target.value) || 0 })} />
                        </Col>
                    </Row>
                </>
            }

            {data && data?.type === 1 &&
                <>
                    <Row>
                        <Col span={12}>
                            <Title className='mt-0' level={4}>Contracts</Title>
                            <Progress percent={contractsPercent} steps={10}
                                status="active"
                                strokeColor={[green[2], green[3], green[4], orange[3], orange[4], orange[5], red[4], red[5], red[6], red[7]]}
                            />
                            <p className='mt-0'>
                                <Text className='mt-0' type="secondary">artist's committed percentage</Text>
                            </p>
                        </Col>
                        <Col span={12}>
                        </Col>
                    </Row >
                    {
                        Object.keys(contracts).length === 0 ? <Empty
                            imageStyle={{ height: 60 }}
                            description={
                                <Typography.Text>
                                    no contract found
                                </Typography.Text>
                            }
                        >
                            <Button onClick={addEmptyContract}>Create Now</Button>
                        </Empty> :
                            <div key={contractsKey}>
                                {!hasNewContract && contracts.length <= 4 &&
                                    <Button
                                        className='mt-4'
                                        type="primary" onClick={addEmptyContract}>Create contract</Button>
                                }
                                {contracts?.map((contract, i) => (
                                    <RepresentationContract
                                        contract={contract}
                                        contracts={contracts}
                                        setContracts={setContracts}
                                        index={i}
                                        hasNewContract={hasNewContract}
                                        setHasNewContract={setHasNewContract}
                                        loading={false}
                                        totalUsedFee={contractsPercent} />
                                ))}
                            </div>
                    }
                </>
            }

            {data && (data?.type === 3 || data?.type === 4) &&
                <>
                    <Row>
                        <Col span={12}>
                            <Title className='mt-0' level={4}>Contracts</Title>
                        </Col>
                        <Col span={12}>
                        </Col>
                    </Row >
                    {
                        Object.keys(contracts).length === 0 ? <Empty
                            imageStyle={{ height: 60 }}
                            description={
                                <Typography.Text>
                                    no contract found
                                </Typography.Text>
                            }
                        >
                            <Button onClick={addEmptyContract}>Create Now</Button>
                        </Empty> :
                            <div key={contractsKey}>
                                {!hasNewContract &&
                                    <Button
                                        className='mt-4'
                                        type="primary" onClick={addEmptyContract}>Create contract</Button>
                                }
                                {contracts?.map((contract, i) => (
                                    <ArtistRepresentationContract
                                        contract={contract}
                                        contracts={contracts}
                                        setContracts={setContracts}
                                        index={i}
                                        hasNewContract={hasNewContract}
                                        setHasNewContract={setHasNewContract}
                                        loading={false} />
                                ))}
                            </div>
                    }
                </>
            }

            <Button
                className='mt-4'
                disabled={(data && Object.keys(data)?.length === 0) || hasNewContract || isAnyEditing}
                type="primary"
                icon={<SaveOutlined />}
                loading={loading}
                onClick={() => save()}
            >
                Save
            </Button>
        </>
    )
}

export default ContractsScreen